/* Tiipi motion layer (DESK-288). Desktop: GSAP 3.12.5 + ScrollTrigger 3.12.5 + Lenis 1.3.27. Phones: no libraries.
   Loaded after first paint (window load + idle), so it never competes with the LCP image.
   Tiers: desktop >= 990px with a fine pointer gets GSAP: Lenis, rise + stagger and a slow image settle;
   phones get the lighter cut: no libraries at all, an IntersectionObserver opacity fade, native scroll;
   prefers-reduced-motion loads nothing and every element stays where the HTML puts it.
   Only elements still below the fold at init are hidden before their reveal, so nothing
   a visitor has already seen can blink. */
(function () {
  if (!window.matchMedia || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var desktop = matchMedia('(min-width: 990px) and (pointer: fine)').matches;

  function load(src) {
    return new Promise(function (ok, fail) {
      var s = document.createElement('script');
      s.src = src; s.async = false; s.onload = ok; s.onerror = fail;
      document.head.appendChild(s);
    });
  }
  function urls() {
    var el = document.getElementById('tp-motion-src');
    return el ? JSON.parse(el.textContent) : null;
  }

  /* Phone cut (DESK-288, cut first for LCP): no GSAP, no ScrollTrigger, no Lenis on phones.
     Below-the-fold groups fade in with one IntersectionObserver and a CSS opacity transition. */
  function phone() {
    if (!('IntersectionObserver' in window)) return;
    var fold = innerHeight, els = [];
    document.querySelectorAll('[data-tp-reveal]').forEach(function (g) {
      var items = g.querySelectorAll('[data-tp-item]');
      (items.length ? Array.prototype.slice.call(items) : [g]).forEach(function (el) {
        if (el.getBoundingClientRect().top > fold) els.push(el);
      });
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.style.opacity = '1'; io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) {
      el.style.opacity = '0'; el.style.transition = 'opacity .5s ease-out'; io.observe(el);
    });
  }

  function init() {
    if (!desktop) return phone();
    var u = urls(); if (!u) return;
    var chain = load(u.gsap).then(function () { return load(u.st); });
    chain = chain.then(function () { return load(u.lenis); });
    chain.then(run).catch(function () {});
  }

  function run() {
    var gsap = window.gsap, ST = window.ScrollTrigger;
    if (!gsap || !ST) return;
    gsap.registerPlugin(ST);

    if (window.Lenis) {
      var lenis = new Lenis({ lerp: 0.1 });
      lenis.on('scroll', ST.update);
      gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
      gsap.ticker.lagSmoothing(0);
      window.tpLenis = lenis;
    }

    var fold = innerHeight;
    var groups = document.querySelectorAll('[data-tp-reveal]');
    groups.forEach(function (g) {
      var items = g.querySelectorAll('[data-tp-item]');
      var targets = items.length ? Array.prototype.slice.call(items) : [g];
      targets = targets.filter(function (el) { return el.getBoundingClientRect().top > fold; });
      if (!targets.length) return;
      gsap.set(targets, { autoAlpha: 0, y: 32 });
      ST.batch(targets, {
        start: 'top 86%', once: true,
        onEnter: function (b) { gsap.to(b, { autoAlpha: 1, y: 0, duration: 0.9, ease: 'expo.out', stagger: 0.09, overwrite: true }); }
      });
    });

    /* photos settle from a slight push-in as they cross the viewport */
    document.querySelectorAll('[data-tp-settle] img').forEach(function (img) {
      gsap.fromTo(img, { scale: 1.08 }, { scale: 1, ease: 'none',
        scrollTrigger: { trigger: img.parentNode, start: 'top bottom', end: 'center center', scrub: 0.6 } });
    });
    ST.refresh();
  }

  function afterPaint() {
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 200); };
    idle(init, { timeout: 2500 });
  }
  if (document.readyState === 'complete') afterPaint(); else addEventListener('load', afterPaint, { once: true });
})();
